<template>
  <div style="height: 100vh;position: relative;overflow: hidden;">
    <el-image
        style="width: 100%; height: 100%;"
        :src="indexPicturePart4"
        :key="indexPicturePart4"
        fit="cover"
        class="animate__animated animate__fadeIn"
    />
    <el-row style="position: absolute;color: white;bottom: 0;height: 45%;width: 100%;text-align: left;line-height: 1.8;font-size: 1.2rem">
      <el-col :span="6"
              :style="{
                paddingLeft: '5%',
                visibility: currentActive !== 0 ? 'visible' : 'hidden',
              }">
        <div>
          AUTOMATION EQUIPMENT
        </div>
        <div class="puHuiTi-regular">自动化设备</div>
      </el-col>
      <el-col :span="6"
              :style="{
                paddingLeft: '5%',
                visibility: currentActive !== 1 ? 'visible' : 'hidden',
              }">
        <div>
          NEW ENERGY EQUIPMENT
        </div>
        <div class="puHuiTi-regular">新能源设备</div>
      </el-col>
      <el-col :span="6"
              :style="{
                paddingLeft: '5%',
                visibility: currentActive !== 2 ? 'visible' : 'hidden',
              }">
        <div>
          MEDICAL EQUIPMENT
        </div>
        <div class="puHuiTi-regular">医疗器械</div>
      </el-col>
      <el-col :span="6"
              :style="{
                paddingLeft: '5%',
                visibility: currentActive !== 3 ? 'visible' : 'hidden',
              }">
        <div>
          TRANSPORTATION
        </div>
        <div class="puHuiTi-regular">交通运输</div>
      </el-col>


    </el-row>
    <el-row class="content-row">
      <el-col :span="6" class="part4-content"
              :style="contentStyle(0)"
              @mouseenter="showContent(0)"
              @mouseleave="hideContent(0)">

        <div class="gothamBold">
          <div>
            <span>AUTOMATION</span>
            <br>
            <span>EQUIPMENT</span>
          </div>

          <div class="puHuiTi-regular" style="margin-top: 0.8rem">自动化设备</div>

          <el-button class="part4-button" @click="$emit('route_jump',{'route':'factoryShow'})">了解一下</el-button>

        </div>
      </el-col>
      <el-col :span="6" class="part4-content"
              :style="contentStyle(1)"
              @mouseenter="showContent(1)"
              @mouseleave="hideContent(1)">

        <div class="gothamBold">
          <div>
            <span>NEW ENERGY </span>
            <br>
            <span>EQUIPMENT</span>
          </div>

          <div class="puHuiTi-regular" style="margin-top: 0.8rem">新能源设备</div>

          <el-button class="part4-button" @click="$emit('route_jump',{'route':'factoryShow'})">了解一下</el-button>

        </div>
      </el-col>
      <el-col :span="6" class="part4-content"
              :style="contentStyle(2)"
              @mouseenter="showContent(2)"
              @mouseleave="hideContent(2)">

        <div class="gothamBold">
          <div>
            <span>MEDICAL</span>
            <br>
            <span>EQUIPMENT</span>
          </div>

          <div class="puHuiTi-regular" style="margin-top: 0.8rem">医疗器械</div>

          <el-button class="part4-button" @click="$emit('route_jump',{'route':'factoryShow'})">了解一下</el-button>

        </div>
      </el-col>
      <el-col :span="6" class="part4-content"
              :style="contentStyle(3)"
              @mouseenter="showContent(3)"
              @mouseleave="hideContent(3)">

        <div class="gothamBold">
          <div>
            <span>TRANSPORTATION</span>
          </div>

          <div class="puHuiTi-regular" style="margin-top: 0.8rem">交通运输</div>

          <el-button class="part4-button" @click="$emit('route_jump',{'route':'factory_show'})">了解一下</el-button>

        </div>
      </el-col>
    </el-row>
    <el-row class="footer-row">
      <el-col :span="6"
              class="part4-footer">
        <div>
          致力于打造高品质的传动部件和解决方案
        </div>
      </el-col>
      <el-col :span="6"
              class="part4-footer">
        <div>
          成为全球领先的传动部件供应商
        </div>
      </el-col>
      <el-col :span="6"
              class="part4-footer">
        <div>
          通过不断创新，提高效率降低成本
        </div>
      </el-col>
      <el-col :span="6"
              class="part4-footer">
        <div>
          实现企业与员工共同发展，最终为客户创在最大效益
        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script setup>
import {ref} from 'vue';

const part4BackImages = ["https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/assets/img/自动化设备.png", "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/assets/img/新能源设备图片.png", "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/assets/img/医疗器械.png", "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/assets/img/交通领域图片.png"]
let indexPicturePart4 = ref(part4BackImages[0])
// 用一个数组来存储每个 content 区域的显示状态
const isHovered = ref([false, false, false, false]);
const currentActive = ref(5)

// 显示对应的 content 区域
const showContent = (index) => {
  currentActive.value = index
  isHovered.value[index] = true;
  indexPicturePart4.value = part4BackImages[index]
};

// 隐藏对应的 content 区域
const hideContent = (index) => {
  isHovered.value[index] = false;
  currentActive.value = 5
};

// 计算每个 content 区域的样式
const contentStyle = (index) => {
  return {
    opacity: isHovered.value[index] ? 1 : 0,
    position: 'relative',
    transition: 'opacity 0.3s ease, visibility 0.3s ease', // 平滑过渡
  };
};
</script>

<style scoped>
.part4-content {
  background-color: rgba(0, 55, 142, 0.8);
  width: 100%;
  position: relative;
  color: white;
  font-size: 1.5rem;
  text-align: left;
  margin-top: 4rem;
}

.part4-footer {
  height: 25vh;
  background-color: black;
  opacity: 0.8;
  color: white;
  text-align: center;
  align-content: center;
  font-size: 1rem;
}
.part4-footer >div{

  width: 80%;
  margin-left: 10%;
}

.content-row {
  position: absolute;
  top: 0;
  width: 100%;
  height: 75%; /* 底部区域高度 */
}

.footer-row {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 25%; /* 底部区域高度 */
}

.part4-content > div {
  margin-left: 3rem;
  margin-top: 5rem;
}

.part4-content > div > span {
  margin-top: 0.5rem;
}

.part4-button {
  border: 1px white solid;
  border-radius: 2rem;
  width: 7rem;
  color: white;
  background-color: transparent;
  position: absolute;
  bottom: 2rem;
  left: 3rem;
}

.part4-button:hover{
  color: #005bd6;
  background-color: white;
}

.animate__fadeIn {
  animation-duration: 1s; /* 将动画持续时间延长至 2 秒 */
}
</style>
